import { UPDATE_PRICE } from "./action";

export const initialState = { 
  bitcoin: 80000,
  solana: 121
};

export default function priceReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PRICE:
      return { ...action.data };
    default:
      return state;
  }
}